export const useRedirects = () => {
  const { useItems } = useCms();
  const { readItems } = useItems();

  const getRedirect = async (slug: MaybeRef<string>) => {
    slug = unref(slug);

    const filter = { slug: { _eq: slug }, status: { _eq: "published" } };
    const limit = 1;
    const fields = ["*", "post.slug", "post.type"];

    return await readItems("redirects", { filter, limit, fields })
      .then((response) => response?.[0] || null)
      .catch(() => null);
  };

  return { getRedirect };
};
